module.exports = __webpack_public_path__ + "static/media/github-select-actions.feecfdca.png";